module.exports = function() {
  return new Worker(__webpack_public_path__ + "2fe6c5cb81b574a67215.worker.js");
};